export const turnstileURL = "https://challenges.cloudflare.com/turnstile/v0/api.js";
export const turnstileManagedTokenKey = "0x4AAAAAAB-3dBvF9bheAO7r";
export const turnstileInvisibleTokenKey = "0x4AAAAAAB-86CtT6I_dyY4j";

export const ISRToken = "my-secret-token-e8a15b8c79e947b4d99cc5e1cf1af9f76b7ec3f949e7e6dd1a67c9fcb790a4a0";

export const ISRClientURL = "https://saralifestyle.com";